// src/components/AdminSidebar.jsx
import { Link, useLocation } from "react-router-dom";

export default function AdminSidebar() {
  const location = useLocation();

  const navItems = [
    { name: "Site Config", path: "/admin" },
    { name: "User Manager", path: "/admin/users" },
    { name: "Bookings", path: "/admin/bookings" },
    { name: "Revenue", path: "/admin/revenue" },
    { name: "Active Users", path: "/admin/active-users" }, // new tracker page
  ];

  return (
    <aside className="w-full md:w-56 bg-black border-b md:border-b-0 p-4">
      <h2 className="text-lg font-bold text-[#D4FF00] mb-4">Admin</h2>
      <nav className="space-y-2">
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`block rounded px-3 py-2 text-sm font-medium transition ${
              location.pathname === item.path
                ? "bg-[#D4FF00] text-black"
                : "text-gray-300 hover:bg-[#D4FF00]/20"
            }`}
          >
            {item.name}
          </Link>
        ))}
      </nav>
    </aside>
  );
}
